<template>
  <v-dialog v-model="visible" persistent>
    <v-card class="v-dialog--custom v-dialog--chart pt-4 pb-2">
      <v-btn
        class="v-dialog--custom__close mr-2"
        color="gray-6"
        flat
        fab
        @click.native="close"
      >
        <v-icon dark>close</v-icon>
      </v-btn>

      <v-card-text
        class="px-4 pt-0 pb-5"
        style="min-height: 500px"
      >
        <PerformanceChart
          v-if="visible"
          :min-height="500"
          :filters="filters"
          dialog
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PerformanceChart from 'components/home/PerformanceChart'

export default {
  name: 'PerformanceChartDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    filters: Object
  },
  components: {
    PerformanceChart
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.v-dialog--chart {

  .v-dialog--custom__close {
    top: 45px;
    z-index: 1;
  }
}
</style>
